import { Analysis } from '../../../types/Survey/Analysis/Analysis'
import {
  PrebuildArbeitstagSubType,
  PrebuildEinzelarbeitSubType,
  PrebuildMeetingGroesseBesprechungSubType,
  PrebuildMeetingGroesseCoworkingSubType,
  PrebuildType,
  Type,
} from '../../../types/Survey/Element'
import { Survey } from '../../../types/Survey/Survey'

type SubType =
  | PrebuildArbeitstagSubType
  | PrebuildEinzelarbeitSubType
  | PrebuildMeetingGroesseBesprechungSubType
  | PrebuildMeetingGroesseCoworkingSubType

type Value = {
  average: number
  answers: number[]
}

const emptyResult: Value = {
  average: 0,
  answers: [],
}

// get values of analysis elements
const getSliderValue = (survey: Survey, analysis: Analysis, type: PrebuildType, subType?: SubType): Value => {
  if (!analysis) return emptyResult
  const surveyElement = survey.elements.find((element) => {
    if (element.type === Type.SLIDER_GROUP) {
      return element.prebuildType === type && element.sliders.some((el) => el.prebuildType === subType)
    } else if (element.type === Type.SLIDER) {
      return element.prebuildType === type
    } else if (element.type === Type.SLIDER_DROPDOWN_GROUP) {
      return element.prebuildType === type && element.sliderDropdowns.some((el) => el.prebuildType === subType)
    } else if (element.type === Type.SLIDER_DROPDOWN) {
      return element.prebuildType === type
    }
    return false
  })

  if (!surveyElement) return emptyResult

  // handle slider groups
  if (surveyElement.type === Type.SLIDER_GROUP) {
    const slider = surveyElement.sliders.find((slider) => slider.prebuildType === subType)
    if (!!slider) {
      const analysisElement = analysis.elements.find((element) => element.uuid === surveyElement.uuid)
      if (!!analysisElement && analysisElement.type === Type.SLIDER_GROUP) {
        const analysisSlider = analysisElement.sliders.find((element) => element.uuid === slider.uuid)
        if (!analysisSlider) return emptyResult
        return analysisSlider.value
      }
    }
  } else if (surveyElement.type === Type.SLIDER) {
    // handle sliders
    const analysisElement = analysis.elements.find((element) => element.uuid === surveyElement.uuid)
    if (!!analysisElement && analysisElement.type === Type.SLIDER) {
      return analysisElement.value
    }
  } else if (surveyElement.type === Type.SLIDER_DROPDOWN_GROUP) {
    // handle slider dropdown groups
    const sliderDropdown = surveyElement.sliderDropdowns.find((sliderDropdown) => sliderDropdown.prebuildType === subType)
    if (!!sliderDropdown) {
      const analysisElement = analysis.elements.find((element) => element.uuid === surveyElement.uuid)
      if (!!analysisElement && analysisElement.type === Type.SLIDER_DROPDOWN_GROUP) {
        const analysisSlider = analysisElement.sliderDropdowns.find((element) => element.uuid === sliderDropdown.uuid)
        if (!analysisSlider) return emptyResult
        return analysisSlider.value
      }
    }
  } else if (surveyElement.type === Type.SLIDER_DROPDOWN) {
    // handle slider dropdowns
    const analysisElement = analysis.elements.find((element) => element.uuid === surveyElement.uuid)
    if (!!analysisElement && analysisElement.type === Type.SLIDER_DROPDOWN) {
      return analysisElement.value
    }
  }
  return emptyResult
}

export default getSliderValue
